<template>
  <div class="top-countdown">
    <div-container>
      <!-- <div class="block">
        <span class="digit">date: {{ dateValue }}</span>
        <span class="digit">now: {{ now }}</span>
      </div> -->
      <div class="block">
        <span class="digit">{{ days | two_digits }}</span>
        <span class="text">DAYS</span>
      </div>
      <div class="block">
        <span class="digit">{{ hours | two_digits }}</span>
        <span class="text">HRS</span>
      </div>
      <div class="block">
        <span class="digit">{{ minutes | two_digits }}</span>
        <span class="text">MINS</span>
      </div>
      <div class="block">
        <span class="digit">{{ seconds | two_digits }}</span>
        <span class="text">SECS</span>
      </div>
    </div-container>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'

export default {
  name: 'top-countdown',
  components: {
    DivContainer
  },
  props: {
    date: {
      type: String,
      coerce: str => Math.trunc(Date.parse(str) / 1000)
    }
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      now: Math.trunc((new Date()).getTime() / 1000)
    }
  },
  computed: {
    dateValue () {
      return Math.trunc(Date.parse(this.date) / 1000)
    },
    seconds: function () {
      if ((this.dateValue - this.now) < 0) return 0
      return (this.dateValue - this.now) % 60
    },
    minutes () {
      if ((this.dateValue - this.now) < 0) return 0
      return Math.trunc((this.dateValue - this.now) / 60) % 60
    },
    hours () {
      if ((this.dateValue - this.now) < 0) return 0
      return Math.trunc((this.dateValue - this.now) / 60 / 60) % 24
    },
    days () {
      if ((this.dateValue - this.now) < 0) return 0
      return Math.trunc((this.dateValue - this.now) / 60 / 60 / 24)
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)

    if (this.$route.query && this.$route.query.anchor) {
      // console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.top-countdown {
  position: relative;
  background-color: $color-orange;
  text-align: center;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }

  .block {
    // display: flex;
    // flex-direction: column;
    display: inline-block;
    margin: 8px 4px;
  }

  .text {
    // color: #1abc9c;
    // font-size: 40px;
    // font-family: 'Roboto Condensed', serif;
    font-weight: bold;
    font-size: 1.25em;
    // margin-top:10px;
    // margin-bottom: 10px;
    margin-left: 3px;
    text-align: center;
  }

  .digit {
    // color: #ecf0f1;
    // font-size: 150px;
    font-weight: bold;
    font-size: 1.25em;
    // font-family: 'Roboto', serif;
    // margin: 10px;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// TopCountdown.vue?327a9e8a